import { h } from 'preact';
import SVGWrapper from '../../../../../../common/components/svg/SvgWrapper';

function TracksActiveIcon({ height = 60, width = 60, color = 'white' }) {
  return (
    <SVGWrapper
      width={width}
      height={height}
      viewBox="0 0 24 24"
      fill="none"
    >
      <path clipRule="evenodd" d="m21.5368 4.65322c.3549-.03256.6632.24647.6632.60293v11.67305c0 .3598-.3122.6412-.6703.6059-.4931-.0487-1.2449-.1159-2.2095-.1834v2.0742c0 .4466-.4703.7375-.8696.5373-.7747-.3889-1.9097-.9577-2.7304-1.3635-.9756-.4824-2.2563-1.1245-2.9977-1.4971-.2377-.0016-.4786-.0029-.7225-.0029-4.58319 0-8.11615.2981-9.52905.4389-.35833.0357-.6709-.2452-.6709-.6053v-11.67715c.00005-.35646.3083-.63549.66328-.60293 1.49671.13729 5.33509.44649 9.53667.44649 4.2017 0 8.0401-.3092 9.5368-.44649zm-17.03675 9.82148h5.99995v-1.35h-5.99995zm7.34995 0h1.2v-1.35h-1.2zm-7.34995-2.7h2.4v-1.35h-2.4zm3.75-1.35v1.35h7.19995v-1.35z" fill={color} fillRule="evenodd" />
    </SVGWrapper>

  );
}

export default TracksActiveIcon;
